import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Save paraphrased content to history
export const saveParaphraseToHistory = async (data) => {
  try {
    const response = await apiClient.post("/detectors/paraphrase-save", data);
    return response.data;
  } catch (error) {
    console.error("Error saving paraphrase:", error);
    throw error.response?.data || error;
  }
};

// Get paraphrase history
export const getParaphraseHistory = async (userId, machineId) => {
  try {
    const response = await apiClient.post("/detectors/paraphrase-history", {
      userId,
      machineId
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paraphrase history:", error);
    throw error.response?.data || error;
  }
};

// Get single paraphrase by ID
export const getParaphraseById = async (id, userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/paraphrase/${id}?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching paraphrase:", error);
    throw error.response?.data || error;
  }
};

// Update paraphrase
export const updateParaphrase = async (id, outputText, title) => {
  try {
    const response = await apiClient.put(`/detectors/paraphrase-update/${id}`, {
      outputText,
      title
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paraphrase:", error);
    throw error.response?.data || error;
  }
};

// Delete paraphrase
export const deleteParaphrase = async (id) => {
  try {
    const response = await apiClient.delete(`/detectors/paraphrase-delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting paraphrase:", error);
    throw error.response?.data || error;
  }
};

// Get paraphrase statistics
export const getParaphraseStats = async (userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/paraphrase-stats?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error.response?.data || error;
  }
};